import { useMemo } from 'react';

import { useAppSelector } from 'shared/lib/redux';

import { defaultStepperConfigSelector } from '../../model';
import type { IStepperFormsSet } from '../../types';

import { recalculateSteps } from './recalculateSteps';

export const useStepper = (steps?: IStepperFormsSet) => {
  const defaultSteps = useAppSelector(defaultStepperConfigSelector);
  const defaultedSteps = steps || defaultSteps;

  return useMemo(() => recalculateSteps(defaultedSteps), [defaultedSteps]);
};
